import store from './store';
import show from './show';
import all from './all';
import items from './items';
import showDeliveryNote from './showDeliveryNote';

export default {
  store,
  show,
  all,
  items,
  showDeliveryNote,
};



// WEBPACK FOOTER //
// ./src/app/services/transfer/index.js